/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to false if you don't want Splash screen.
};
const splashScreen = {
  useLottie: true, // setting it false will show animation of src/components/loader
  animationFile:
    "starLoading" /* Supported Values
                                     1. splashAnimation
                                     2. email
                                     3. build
                                     4. landingPerson
                                     5. codingPerson
                                     6. geometricLoader
                                     7. starLoading
                                     8. ripple
                                     9. nightDay
                                     10. littleRobot
                                     11. poolChartLoading
                                     */,
  duration: 3500, // Set animation duration(milliseconds) as per your animation
};
//SEO Related settings
const seo = {
  title: "Dipraj's Portfolio",
  description:
    " Passionate software engineer with expertise in web development,data analysis, and AI-based solutions. Proficient in designing and implementing innovative projects with user-centric approaches, ensuring efficiency and collaboration. Seeking to leverage my technical skills in a dynamic organization",
  og: {
    title: "Dipraj Dhar Portfolio",
    type: "website",
    
    url: "http://diprajdhar.com/",
  },
};

//Home Page
const greeting = {
  title: "Dipraj Dhar",
  logo_name: "D_D",
  nickname: "<Software Engineer/>",
  subTitle:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  resumeLink:
    "https://drive.google.com/file/d/17xb-im3XtR-3d3cV6TGqO9mKrTUC1x3h/view?usp=drive_link",
  portfolio_repository: "https://github.com/dipgitcom",
  githubProfile: "https://github.com/dipgitcom",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/dipgitcom",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/diprajdhar/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "YouTube",
    link: "https://youtube.com/c/Dipraj_Dhar",
    fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
    backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  },
  {
    name: "Gmail",
    link: "mailto:diprajdhar08@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "X-Twitter",
    link: "https://twitter.com/dipraj",
    fontAwesomeIcon: "fa-x-twitter", // Reference https://fontawesome.com/icons/x-twitter?f=brands&s=solid
    backgroundColor: "#000000", // Reference https://simpleicons.org/?q=x
  },
  
];

const skills = {
  data: [
    {
      title: "Data Science & Machine Learning",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing highly scalable production analysis using numpy, pandas, matplotlib and show with StreamIT and Flask.",
        "⚡ Experience of working with Data Science Project",
        
      ],
      softwareSkills: [
        {
          skillName: "numpy",
          fontAwesomeClassname: "logos-numpy",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "pandas",
          fontAwesomeClassname: "simple-icons:pandas",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "matplotlib",
          fontAwesomeClassname: "logos-matplotlib",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
       
      
      ],
    },
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive website front end using React-Redux,HTML,CSS,Javascript,Bootsrap",
        
        "⚡ Creating application backend in Node, Express,PHP,Laravel(PHP framework)",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Bootstrap",
          fontAwesomeClassname: "simple-icons:bootstrap",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "devicon-plain:nodejs-wordmark",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "MySql",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#2C8EBB",
          },
        },
        {
          skillName: "PHP",
          fontAwesomeClassname: "simple-icons:php",
          style: {
            color: "#2C8EBB",
          },
        },
        {
          skillName: "Laravel",
          fontAwesomeClassname: "simple-icons:laravel",
          style: {
            color: "#2C8EBB",
          },
        },
        
      ],
    },
   
   
  ],
};

  

  
// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/u/d_i_p10",
    },
    
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/neat_owls_92",
    },
    {
      siteName: "Codeforces",
      iconifyClassname: "simple-icons:codeforces",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "https://codeforces.com/profile/dipraj108",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/diprjdhr",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Noakhali Science And Technology University",
      subtitle: "Bachelor Science of Software Engineering(IIT)",
      logo_path: "nstu-1.png",
      alt_name: "nstu",
      duration: "2021 - 2025",
      descriptions: [
        "⚡ I have studied software engineering subjects like DS, Algorithms, DBMS, OS,OOP,CA,Design patterns etc.",
        "⚡ Apart from this, I have done courses on Artificial Intelligence, Data Science, Cloud Computing and Full Stack Development.",
        "⚡ This Course is maintained by 8 semester.",
        "⚡ My CGPA - 3.4+ / 4.00",
        
      ],
      website_link: "https://nstu.edu.bd/",
    },
    {
      title: "Chittagong Collegiate School & College",
      subtitle: "High School",
      logo_path: "ccs.png",
      alt_name: "Indiana University Bloomington",
      duration: "2012 - 2018",
      descriptions: [
        "⚡ During my time in high school, I was actively involved in the school media club, where I helped with video editing, school events, and digital content creation.",
       
        "⚡ Result - PSC = 5.0/5.0 JSC = 5.0/5.0 SSC = 5.0/5.0",
      ],
      website_link: "https://ctgcs.edu.bd/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Machine Learning with Python",
      subtitle: "- IBM",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/1aKYobS76OtNgEyjMkzWw8A4h8preb5Po/view?usp=drive_link",
      alt_name: "IBM",
      color_code: "#8C151599",
    },
    {
      title: "British Counsil English Course",
      subtitle: "- British Council",
      logo_path: "british.png",
      certificate_link:
        "https://drive.google.com/file/d/1vvKrZqWNxUd6P5AVy48RPfOBPnf6tILq/view?usp=drive_link",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "Node.js",
      subtitle: "-SimpliLearn",
      logo_path: "simpli.png",
      certificate_link:
        "https://drive.google.com/file/d/1VW_QcXZxKMU_dPRsn3-F15DZPFhAY_N8/view?usp=drive_link",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "Machine Learning",
      subtitle: "-Microsoft",
      logo_path: "microsoft_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/12HAHAU2V-luh4zW7fIsnPsoTSrg2G5Hb/view?usp=drive_link",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Ai Concept",
      subtitle: "- Microsoft",
      logo_path: "microsoft_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/1uxN5Ik3YLRq-uJFF-onETPeSMU_bsdMv/view?usp=drive_link",
      alt_name: "Microsoft",
      color_code: "#D83B0199",
    },
    {
      title: "Digital Business Skill",
      subtitle: "-Hp LIfe",
      logo_path: "hp.png",
      certificate_link:
        "https://drive.google.com/file/d/1vAE96Of67kynCJxw9k2WtWxRx14G5bKN/view?usp=drive_link",
      alt_name: "HP",
      color_code: "#1F70C199",
    },
    {
      title: "Data Analytics",
      subtitle: "- HP Life",
      logo_path: "hp.png",
      certificate_link:
        "https://drive.google.com/file/d/10bzMBOITztLHOiXUjhsV74KIf7KPxTV4/view?usp=drive_link",
      alt_name: "HP",
      color_code: "#0C9D5899",
    },
    {
      title: "Machine Intelligence Emerging Technology",
      subtitle: "-Volunteer",
      logo_path: "miet.png",
      certificate_link:
        "https://drive.google.com/file/d/1z_em-PmfghZ8aNOEDODLeMdML2KmgFOE/view?usp=drive_link",
      alt_name: "MIET",
      color_code: "#00000099",
    },
    {
      title: "Software Showcase Champion",
      subtitle: "- IIT",
      logo_path: "iit.jpeg",
      certificate_link:
        "https://drive.google.com/file/d/17iCnR9L-VBOrTPhwGI6NII-bdNJpCC29/view?usp=drive_link",
      alt_name: "Coursera",
      color_code: "#2A73CC",
    },
    
    
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "I have worked with many evolving startups as Web Developer, Designer and Ml & Data Science project.I love organising events and that is why I am also involved with many opensource communities as a representative.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Undergraduate Software Engineer",
          company: "Nstu.inc",
          company_url: "https://www.nstu.bd",
          logo_path: "nstu-1.png",
          duration: "Still...",
          location: "Bangladesh",
          description:
            "Still studying BSSE- Bachelor Science of Software Engineering.",
          color: "#000000",
        },
     ],
    },

    {
      title: "Internships",
      experiences: [
        {
          title: "Data Science Intern",
          company: "CodeAlpha",
          company_url: "https://www.codealpha.tech/",
          logo_path: "codealpha.jpeg",
          duration: "Nov 2024 - Dec 2024",
          location: "Lucknow, Uttarpradesh, India",
          description:
            "This is mainly virtual internship to worked on some project.Building new features on the backend recommendation system, specifically ranking algorithms for Ads that touch hundreds of millions of people around the world. Improving online and offline content ranking algorithms by performing hard sample data replays for training steps.",
          color: "#000000",
        },
        {
          title: "AI & ML Intern",
          company: "Brainwave Matrix Solution Ltd",
          company_url: "https://matrixbrainwave.in.net/",
          logo_path: "brain.jpeg",
          duration: "Jan 2025 - March 2025",
          location: "Delhi, India",
          description:
            "This is mainly virtual internship.I have worked on project of predicting freight rates based on previous data. ",
          color: "#ee3c26",
        },
       
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "International Conference on Machine Intelligence & Emerging Technologies ",
          company: "MIET",
          company_url: "https://confmiet.org/",
          logo_path: "miet.png",
          duration: "August 2024",
          location: "Noakhali Science And Technology UNiversity,Nstu",
          description:
            "The aim of this conference is to provide an opportunity of engaging researchers, academicians, industry professionals and experts of multi-disciplinary field and sharing their cutting-edge research results through the application of Machine Learning, Data Science, Internet of Things, Cloud Computing, Sensing and Security. Researchers of the relevant fields are invited to submit their original, novel, and extended unpublished works in this conference.",
          color: "#4285F4",
        },
        {
          title: "Software Showcase- 2024",
          company: "IIT",
          company_url: "https://www.iit_nstu.com/",
          logo_path: "iit.jpeg",
          duration: "Sep 2024",
          location: "Nstu,Noakhali",
          description:
            "It is basically a Software Showcase Competition in my university.Where I am an organizer.",
          color: "#D83B01",
        },
       
        
      ],
    },
    {
      title: "Leadership Program",
      experiences: [
        {
          title: "Aspire Institute,Harvard University",
          company: "Aspire Institute",
          company_url: "https://www.aspireleaders.org/",
          logo_path: "aspire.png",
          duration: "March 2025 - May 2025",
          location: "Cambridge, MA, USA",
          description:
            "A future where every young person achieves their full potential and contributes their leadership and talents to build thriving communities.To prepare low-income, first-generation college students worldwide to be leaders in their communities and reach their full potential academically and professionally through a fully funded leadership development program.",
          color: "#4285F4",
        },
        
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Web Development project, Data Science projects etc.",
  avatar_image_path: "projects_image.svg",

  
};




// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "Dip.jpg",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with ML, AI, React, Android, Cloud and Opensource Development.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I like to document some of my experiences in professional career journey as well as some technical knowledge sharing.",
    link: "https://blogs.diprajdhar.com/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Chattogram,Bangladesh",
    locality: "Chattogram",
    country: "Bangladesh",
    region: "Bangladesh",
    postalCode: "4000",
    streetAddress: "Teribazar",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl/HW4vJt4w7uyuVtLq7",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  splashScreen,
  
  contactPageData,
};
